import { httpsCallable } from "firebase/functions";
import { functions } from "./app";

export const parse = httpsCallable(functions, "parse");
